module.exports = __webpack_public_path__ + "img/Codigo_Facilito.813ba289.jpg";